
<Accordion
	:open="open"
	data-qa-form-accordion
	:data-qa-accordion-field="title"
	:bottom-border="true"
>
	<template #header>
		<Slab
			:effects="false"
			size="medium"
			type="transparent"
			:no-padding="true"
			:overflow="'visible'"
			class="cursor-pointer"
			@click="open = !open"
		>
			<Container padding="16px 0px">
				<Typography data-qa-accordion-title type="p1">{{ title }}</Typography>
			</Container>

			<template #secondary-actions>
				<Icon
					name="i-chevron-down"
					class="margin-rt-12"
					type="filled"
					size="small"
					data-qa-toggle-accordion
					:rotate="open ? 180 : 0"
					@click.stop="open = !open"
				/>
			</template>
		</Slab>
	</template>
	<slot />
</Accordion>
